<template>
  <div>
    <!-- <TitleLogo title="공주의 앨범 상세보기" />
    <v-divider></v-divider> -->
    <v-sheet v-if="isLoading" class="text-center mt-10">
      <div class="font-weight-medium text-body-1 pb-4">Loading...</div>
      <v-progress-circular size="48" :width="2" color="primary" indeterminate></v-progress-circular>
    </v-sheet>

    <v-sheet v-else-if="isPremiumPicture" class="premium-album-detail pb-10 mx-auto">
      <header class="premium-album-heading px-4 pt-5 pb-4">
        <button type="button" class="album-back" @click="goToAlbum">‹ 공주의 앨범</button>
        <p>MY PRINCESS ALBUM</p>
        <h1>{{ item.title || "프리미엄 사진" }}</h1>
      </header>

      <div class="premium-photo-frame mx-4">
        <v-img :src="item.imageUrl" :lazy-src="item.thumbnailUrl" :key="item.imageUrl" contain aspect-ratio="0.8">
          <template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular color="#b4863e" indeterminate></v-progress-circular>
            </div>
          </template>
        </v-img>
      </div>

      <div class="premium-photo-actions px-4 pt-4">
        <button type="button" class="album-action secondary" @click="openUrlForDownload">사진 저장</button>
        <button type="button" class="album-action primary" @click="createPhotoCard">카드 보내기</button>
      </div>

      <section class="album-reply-section mx-4 mt-7">
        <div class="album-section-title">
          <div>
            <small>REPLIES</small>
            <h2>친구들의 답장</h2>
          </div>
          <span>{{ replyEntries.length }}</span>
        </div>
        <div v-if="replyEntries.length" class="album-reply-list">
          <article v-for="reply in replyEntries" :key="`${reply.cardId}-${reply.id}`">
            <p>{{ reply.message }}</p>
            <small>{{ reply.packageLabel }} · {{ formatDate(reply.created) }}</small>
          </article>
        </div>
        <p v-else class="album-empty-replies">이 사진으로 카드를 보내면 친구의 답장이 여기에 모여요.</p>
      </section>

      <section v-if="cards.length" class="album-card-section mx-4 mt-4">
        <div class="album-section-title compact">
          <h2>보낸 카드</h2>
          <span>{{ cards.length }}</span>
        </div>
        <article v-for="card in cards" :key="card.id" class="album-card-item">
          <div>
            <strong>{{ cardTypeLabel(card.package_type) }}</strong>
            <small>{{ card.opened_at ? "친구가 확인했어요" : "아직 확인 전이에요" }}</small>
          </div>
          <div class="album-card-actions">
            <button type="button" @click="shareCard(card)">보내기</button>
            <button type="button" class="delete" @click="revokeCard(card)">삭제</button>
          </div>
        </article>
      </section>
    </v-sheet>

    <v-sheet v-else class="pb-4 mx-auto">
      <div class="d-flex justify-center align-center pb-1" style="gap: 16px">
        <IconButton 
              :icon-src="require('@/assets/buttons/download_light_ic.png')"
              :text="$t('button.save')"
              @click="openUrlForDownload()"
              :isLight="true"
            />
            <IconButton 
              :icon-src="require('@/assets/buttons/magic_light_ic.png')"
              :text="$t('button.modify')"
              @click="showEditPreConfirm = true"
              :isLight="true"
            />
            <IconButton 
              :icon-src="require('@/assets/buttons/print_light_ic.png')"
              :text="$t('button.print-1')"
              @click="showPrintConfirm = true"
              :isLight="true"
            />
            <IconButton 
              :icon-src="require('@/assets/buttons/review_light_ic.png')"
              :text="hasReview ? $t('button.review-edit') : $t('button.review-write')"
              @click="writeReview()"
              :isLight="true"
            />
      </div>
      <v-img class="sela-dialog-card-content" :src="item.imageUrl" :lazy-src="item.thumbnailUrl" :key="item.imageUrl" contain>
        <template v-slot:placeholder>
          <div class="d-flex align-center justify-center fill-height">
            <v-progress-circular color="white" indeterminate></v-progress-circular>
          </div>
        </template>
      </v-img>
<!--
      <div class="px-4 py-2">
        <PanelButton @click="showEditConfirm = true" :disabled="!isEditable(item)" :title="$t('dialog.edit-composite')" :message="$t('dialog.edit-guide')" />

        <div style="height: 6px"></div>

        <PanelButton @click="goToPrintReq" :title="$t('page.pictureDetail.print-title')" :message="$t('page.pictureDetail.print-subtitle')" />

        <div class="d-flex justify-center align-center py-2" style="gap: 8px">
          <v-btn outlined class="sela deactivate text-body-1" @click="shareImage()" style="flex-grow: 1"> {{ $t("button.friend-share") }} </v-btn>
          <v-btn outlined class="sela deactivate text-body-1" @click="writeReview()" width="32%"> {{ hasReview ? $t("button.review-edit") : $t("button.review-write") }} </v-btn>
          <v-btn outlined class="sela text-body-1" @click="openUrlForDownload()" width="25%"> {{ $t("button.savein-myphone") }}</v-btn>
        </div>
      </div>
-->
      <ReviewWriteDialog v-if="reviewDialog" :visible="reviewDialog" :item="item" @close="reviewDialog = false" :key="item.id" />

      <ConfirmDialog 
        @confirm="editPicture()" 
        @cancel="showEditConfirm = false" 
        :visible="showEditConfirm" 
        :message="$t('dialog.edit-start-confirm')" 
        @input="(e) => (showEditConfirm = e)"
      />
      <ActionConfirmDialog 
        @confirm="goToPrintReq" 
        @cancel="showPrintConfirm = false" 
        :visible="showPrintConfirm" 
        title="즉시 인쇄" 
        :message="$t('dialog.print-warning-guide-message')" 
        @input="(e) => (showPrintConfirm = e)"
        :iconSrc="require('@/assets/buttons/print_light_ic.png')"
        :centerImage="require('@/assets/guide/lafia-print-caution.png')"
      />
      <ActionConfirmDialog 
        @confirm="
          showEditPreConfirm = false
          showEditConfirm = true
        "
        @cancel="showEditPreConfirm = false" 
        :visible="showEditPreConfirm" 
        :title="$t('button.modify')" 
        :message="$t('dialog.edit-pre-warning-guide-message')" 
        @input="(e) => (showEditPreConfirm = e)"
        :iconSrc="require('@/assets/buttons/magic_light_ic.png')"
        :centerImage="require('@/assets/guide/lafia-magic-caution.png')"
      />
    </v-sheet>
  </div>
</template>
<script>
import TitleLogo from "@/views/components/TitleLogo"
import DialogHeader from "@/views/components/DialogHeader"
import ReviewWriteDialog from "./components/ReviewWriteDialog"
import { fetchMyPictureItem } from "@/models/MyPicture"
import ConfirmDialog from "@/views/components/ConfirmDialog"
//import PanelButton from "@/views/components/PanelButton"
import IconButton from "@/views/components/IconButton"
import ActionConfirmDialog from "@/views/components/ActionConfirmDialog"

export default {
  components: {
    TitleLogo,
    DialogHeader,
    ReviewWriteDialog,
    ConfirmDialog,
    //PanelButton,
    IconButton,
    ActionConfirmDialog,
  },

  data: () => ({
    item: null,
    isLoading: true,
    reviewDialog: false,
    hasReview: false,
    showEditConfirm: false,

    showPrintConfirm: false,
    showEditPreConfirm: false,
    cards: [],
  }),

  created() {},

  mounted() {
    if (this.isPremiumPicture) {
      this.loadPremiumPicture()
      return
    }

    fetchMyPictureItem(this, this.$route.params.id)
      .then((item) => {
        this.item = item
        console.log("MyPictureDialog mounted", this.item)

        if (this.item) {
          this.$http
            .post("/api/review/select/request", {
              params: {
                requestId: this.item.id,
              },
            })
            .then((res) => {
              if (res.data.length > 0) {
                this.hasReview = true
              } else {
                this.hasReview = false
              }
            })
        }
      })
      .catch((e) => {
        console.log(e)
        alert(this.$t("alert.error_failed_get_information"))
        this.$router.back()
      })
      .finally(() => {
        this.isLoading = false
      })
  },

  computed: {
    isPremiumPicture() {
      return /^premium-\d+$/.test(String(this.$route.params.id || ""))
    },
    premiumAssetId() {
      const match = String(this.$route.params.id || "").match(/^premium-(\d+)$/)
      return match ? Number(match[1]) : null
    },
    replyEntries() {
      return this.cards
        .reduce((result, card) => {
          const packageLabel = this.cardTypeLabel(card.package_type)
          return result.concat(
            (card.replies || []).map((reply) => ({
              ...reply,
              cardId: card.id,
              packageLabel,
            }))
          )
        }, [])
        .sort((left, right) => new Date(right.created) - new Date(left.created))
    },
  },

  methods: {
    async loadPremiumPicture() {
      try {
        const [photoResponse, cardResponse] = await Promise.all([
          this.$http.get(`/api/photo-deliveries/completed/${this.premiumAssetId}`),
          this.$http.get(`/api/photo-cards/mine?assetId=${this.premiumAssetId}`),
        ])
        const photo = photoResponse.data
        this.item = {
          ...photo,
          imageUrl: photo.complete_url,
          thumbnailUrl: photo.thumbnail_url,
        }
        this.cards = cardResponse.data.cards || []
      } catch (error) {
        console.log(error)
        alert(this.$t("alert.error_failed_get_information"))
        this.goToAlbum()
      } finally {
        this.isLoading = false
      }
    },

    goToAlbum() {
      this.$router.push("/mypage/home?type=picture")
    },

    createPhotoCard() {
      const reservationId = encodeURIComponent(this.item.reservation_id || "")
      window.location.href = `/photo-card/create.html?assetId=${this.premiumAssetId}&reservationId=${reservationId}`
    },

    cardTypeLabel(type) {
      return {
        gift: "선물처럼 보낸 카드",
        letter: "사진 편지",
        princess: "공주처럼 보낸 카드",
      }[type] || "사진 카드"
    },

    formatDate(value) {
      if (!value) return ""
      return this.dayjs(value).format("YYYY.M.D")
    },

    async shareCard(card) {
      const url = new URL(card.share_url, window.location.origin).href
      if (navigator.share) {
        try {
          await navigator.share({ title: "라피아 사진 카드", url })
          return
        } catch (error) {
          if (error && error.name === "AbortError") return
        }
      }
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(url)
        alert("카드 주소를 복사했습니다.")
      } else {
        window.prompt("아래 주소를 복사해 보내주세요.", url)
      }
    },

    async revokeCard(card) {
      if (!confirm("이 카드 주소를 더 이상 열 수 없게 할까요?")) return
      await this.$http.delete(`/api/photo-cards/${card.id}`)
      const response = await this.$http.get(`/api/photo-cards/mine?assetId=${this.premiumAssetId}`)
      this.cards = response.data.cards || []
    },

    async shareImage() {
      await this.$shareLink(this.item.imageUrl)
    },

    writeReview() {
      this.reviewDialog = true
    },

    downloadImage() {
      const a = document.createElement("a")
      a.href = this.item.imageUrl
      a.download = this.item.filename
      a.click()
    },
    openUrlForDownload() {      
      const encodedUrl = encodeURIComponent(this.item.complete_url)
      window.open("https://front.lafia-studio.com/imageViewer-v2.html?imageUrl=" + encodedUrl, "_blank")
    },
    editPicture() {
      this.$router.push(`/mypage/picEdit/${this.item.id}`)
    },

    isEditable(item) {
      if (!item.editable || !item.completeDate) {
        return false
      }
      const isBaseEditableDate = "24.5.1"
      const isBaseEditableDay = this.dayjs(isBaseEditableDate, "YY.M.D", true)
      const completeDay = this.dayjs(item.completeDate, "YY.M.D", true)

      if (completeDay.isBefore(isBaseEditableDay)) {
        return false
      } else {
        return true
      }
    },

    goToPrintReq() {
      this.$router.push({ name: "printPicPay", params: { id: this.$route.params.id, pic: this.item } })
    },
  },
}
</script>
<style scoped>
.premium-album-detail {
  max-width: 580px;
  color: #44352e;
  background: #fffdf9;
}

.premium-album-heading {
  text-align: center;
}

.premium-album-heading p {
  margin: 10px 0 2px;
  color: #b4863e;
  font-size: 11px;
  letter-spacing: 0.18em;
}

.premium-album-heading h1 {
  margin: 0;
  font-family: serif;
  font-size: 24px;
  font-weight: 500;
}

.album-back {
  display: block;
  min-height: 36px;
  padding: 0;
  border: 0;
  color: #77665d;
  background: transparent;
  font-size: 13px;
}

.premium-photo-frame {
  overflow: hidden;
  border: 1px solid rgba(180, 134, 62, 0.32);
  border-radius: 14px;
  background: #f7f1ea;
  box-shadow: 0 14px 34px rgba(79, 56, 40, 0.12);
}

.premium-photo-actions {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr;
  gap: 9px;
}

.album-action {
  min-height: 50px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
}

.album-action.secondary {
  border: 1px solid #ddc9aa;
  color: #8a642b;
  background: #fff;
}

.album-action.primary {
  border: 1px solid #b4863e;
  color: #fff;
  background: linear-gradient(135deg, #c99c50, #a67632);
  box-shadow: 0 8px 18px rgba(164, 111, 43, 0.2);
}

.album-reply-section,
.album-card-section {
  padding: 18px;
  border: 1px solid #eadfce;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.86);
}

.album-section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 13px;
}

.album-section-title small {
  display: block;
  color: #b4863e;
  font-size: 9px;
  letter-spacing: 0.16em;
}

.album-section-title h2 {
  margin: 2px 0 0;
  font-size: 18px;
}

.album-section-title > span {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  border-radius: 50%;
  color: #8a642b;
  background: #f6ede0;
  font-size: 12px;
}

.album-reply-list {
  display: grid;
  gap: 8px;
}

.album-reply-list article {
  padding: 12px 13px;
  border-radius: 11px;
  background: #faf6f0;
}

.album-reply-list p {
  margin: 0 0 4px;
  font-size: 14px;
  line-height: 1.55;
}

.album-reply-list small,
.album-card-item small {
  color: #948178;
  font-size: 10px;
}

.album-empty-replies {
  margin: 0;
  padding: 14px 8px;
  color: #8e7d74;
  text-align: center;
  font-size: 13px;
}

.album-section-title.compact {
  margin-bottom: 8px;
}

.album-section-title.compact h2 {
  font-size: 15px;
}

.album-card-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 11px 0;
  border-top: 1px solid #f0e7da;
}

.album-card-item strong,
.album-card-item small {
  display: block;
}

.album-card-actions {
  display: flex;
  gap: 5px;
}

.album-card-actions button {
  min-width: 50px;
  min-height: 36px;
  border: 1px solid #dfcfb8;
  border-radius: 9px;
  color: #7c5c30;
  background: #fff;
  font-size: 12px;
}

.album-card-actions .delete {
  color: #a34e56;
}
</style>
